import { useQuery } from '@apollo/client';
import * as Sentry from '@sentry/react';

import BrowseProjectsForUser from 'bundles/account-profile/components/recruiting-profile-viewer/queries/BrowseProjectsForUser.graphql';
import type {
  BrowseProjectsForUserQuery as BrowseProjectsForUserData,
  BrowseProjectsForUserQueryVariables,
} from 'bundles/account-profile/components/recruiting-profile-viewer/queries/__generated__/BrowseProjectsForUser';

export const useBrowseProjectsData = (userId: string) => {
  const { loading, data } = useQuery<BrowseProjectsForUserData, BrowseProjectsForUserQueryVariables>(
    BrowseProjectsForUser,
    {
      variables: { userId },
      skip: !userId,
      context: { clientName: 'gatewayGql' },
      onError: (error) => {
        Sentry.captureException(error, {
          extra: { message: 'Error fetching browse projects data' },
        });
      },
    }
  );

  const projects = data?.UserPortfolioProject?.browseProjectsForUser?.elements;

  return {
    isLoading: loading,
    projects: projects || [],
  };
};

export default useBrowseProjectsData;
